import React from 'react';
import {
  Box,
  Typography,
  Button,
  Paper
} from '@mui/material';
import {
  CloudUpload,
  FolderOpen
} from '@mui/icons-material';
import './UploadArea.css';

const UploadArea = ({ dragActive, handleDrag, handleDrop, onFolderSelect }) => (
  <Paper 
    className={`upload-area ${dragActive ? 'drag-active' : ''}`}
    onDragEnter={handleDrag}
    onDragLeave={handleDrag}
    onDragOver={handleDrag}
    onDrop={handleDrop}
    elevation={0}
  >
    <Box className="upload-content">
      <CloudUpload className="upload-icon" />
      <Typography variant="h6" className="upload-title">
        Drag & Drop PDF files here
      </Typography>
      <Typography variant="body2" className="upload-subtitle">
        or select a binder
      </Typography>
      
      <Box className="upload-buttons">
        <Button
          variant="contained"
          startIcon={<FolderOpen sx={{ fontSize: 18 }} />}
          onClick={onFolderSelect}
          className="select-folder-btn"
        >
          Select Binder
        </Button>
      </Box>
    </Box>
  </Paper>
);

export default UploadArea;
